const FmFileCategoryType = {
	Directory: 'Mappa',
	File: 'Fájl',
	Image: 'Kép',
	Document: 'Dokumentum'
};

export default FmFileCategoryType;
